module.exports = ".nav-disabled {\n  color: grey; }\n"